/** Le compteur exact reste disponible dans le libellé accessible et l’infobulle. */
export function formaterCompteurSynthese(nombre: number | null): string {
  if (nombre === null) return '—';
  if (nombre < 1000) return String(nombre);
  if (nombre < 10000) return `${(nombre / 1000).toFixed(1)}k`;
  return `${Math.round(nombre / 1000)}k`;
}
